import { Box, styled } from '@mui/material';
import { LwFormSelect } from 'redesign';
import { useFormContext, useWatch } from 'react-hook-form';
import { AndBlockProps } from './and-block.types';
import { EnrollEntityIdsField } from './enroll-entity-ids-field';
import { BlockHeader } from '../block-header/block-header';
import { Condition, EnrollNodeFormValues } from '../../enroll-node-editor.types';

const conditionOptions: { label: string; value: Condition }[] = [
  { label: 'Is equal to', value: 'equal' },
];

export const AndBlock = ({
  entityTypeOptions: entityTypeOptionsProp,
  entityOptions,
  usedEntityTypes,
  andIndex,
  orIndex,
  canRemove,
  onRemove,
}: AndBlockProps) => {
  const { control, setValue } = useFormContext<EnrollNodeFormValues>();

  const selectedType = useWatch({
    control,
    name: `orBlocks.${orIndex}.andBlocks.${andIndex}.entityType`,
  });

  const filteredTypeOptions = entityTypeOptionsProp.filter(
    (option) => !usedEntityTypes.includes(option.value) || option.value === selectedType
  );

  const currentEntityOptions = selectedType ? entityOptions[selectedType] : [];

  return (
    <AndBlockWrapper>
      <BlockHeader
        title={`AND condition #${andIndex + 1}`}
        onRemove={onRemove}
        canRemove={canRemove}
      />
      <LwFormSelect
        name={`orBlocks.${orIndex}.andBlocks.${andIndex}.entityType`}
        label="Entity type"
        control={control}
        options={filteredTypeOptions}
        rules={{ required: true }}
        defaultLabel="Select entity type"
        onChange={() => {
          setValue(`orBlocks.${orIndex}.andBlocks.${andIndex}.entityId`, []);
        }}
      />
      <LwFormSelect
        name={`orBlocks.${orIndex}.andBlocks.${andIndex}.condition`}
        label="Condition"
        control={control}
        disabled={true}
        rules={{ required: true }}
        options={conditionOptions}
      />
      <EnrollEntityIdsField
        control={control}
        name={`orBlocks.${orIndex}.andBlocks.${andIndex}.entityId`}
        label="Entity"
        options={currentEntityOptions}
        disabled={!selectedType}
      />
    </AndBlockWrapper>
  );
};

const AndBlockWrapper = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.lwPrimaryAccentLight[100]}`,
  borderRadius: 12,
  padding: '16px',
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  width: '100%',
  flexShrink: 0,
}));
